import { render } from "./ProgramLinkedInformationListView.vue?vue&type=template&id=a9a13dea&scoped=true&ts=true"
import script from "./ProgramLinkedInformationListView.vue?vue&type=script&lang=ts"
export * from "./ProgramLinkedInformationListView.vue?vue&type=script&lang=ts"

import "./ProgramLinkedInformationListView.vue?vue&type=style&index=0&id=a9a13dea&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9a13dea"]])

export default __exports__